module.exports = __webpack_public_path__ + "static/img/thumb-04.d531592.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/dhl/thumb/thumb-04.png
// module id = PxRC
// module chunks = 150